document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  const plusBtn = form.querySelector('.plus');
  const minBtn = form.querySelector('.min'); 
  const qtyInput = form.querySelector('.quantity__input');
  const variantIdField = form.querySelector('[name="id"]');
  const variantRadioButtons = document.querySelectorAll('[data-variant-picker] input[type="radio"]');

  console.log('plusBtn', plusBtn);
  console.log('qtyInput', qtyInput);

  let maxQuantity = parseInt(qtyInput.dataset.maxQuantity, 10);
  console.log('maxQuantity', maxQuantity);
  console.log(qtyInput.dataset.maxQuantity);

  const notification = form.querySelector('#max-quantity-notification');
  const stockNotification = form.querySelector('#stock-notification');

  let isUpdating = false;

  function updateQuantity(newValue, shouldDispatchEvent = true) {
    console.log('updating qty');
    console.log('updating', isUpdating)
    if (isUpdating) return; // Prevent recursive calls
    isUpdating = true;
    console.log('updating', isUpdating)

    newValue = Math.max(1, Math.min(newValue, maxQuantity));
    qtyInput.value = newValue;

    console.log('newValue', newValue)
    console.log(qtyInput)

    if (newValue < maxQuantity || maxQuantity == 0) {
      notification?.classList.add('hidden');
    } else {
      notification?.classList.remove('hidden');
    }

    plusBtn.classList.toggle('disabled', newValue >= maxQuantity);
    minBtn.classList.toggle('disabled', newValue <= 1);

    if (shouldDispatchEvent) {
      // Dispatch the change event
      const event = new Event('change', { bubbles: true });
      qtyInput.dispatchEvent(event);
    }

    isUpdating = false;
  }

  function updatePrices(variantPrice, variantComparePrice) {
    const totalPrice = document.getElementById('total-price');
    const defaultPrice = document.getElementById('default-price');
    const totalComparePrice = document.getElementById('total-compare-price');
    const defaultComparePrice = document.getElementById('default-compare-price');
    const discountElement = document.querySelector('.bg-light.p-1\\.5.text-white.inline-block.text-xs.font-bold.mb-2');

    if (totalPrice && defaultPrice) {
      totalPrice.textContent = formatMoney(variantPrice);
      totalPrice.setAttribute('data-original-price', variantPrice / 100);
      totalPrice.setAttribute('data-excl-price', variantPrice);
      defaultPrice.textContent = formatMoney(variantPrice);
      defaultPrice.setAttribute('data-excl-price', variantPrice);
    }

    if (totalComparePrice && defaultComparePrice) {
      if (variantComparePrice > variantPrice) {
        totalComparePrice.textContent = formatMoney(variantComparePrice);
        totalComparePrice.setAttribute('data-excl-price', variantComparePrice);
        defaultComparePrice.textContent = formatMoney(variantComparePrice);
        defaultComparePrice.setAttribute('data-excl-price', variantComparePrice);
        totalComparePrice.classList.remove('hidden');
      } else {
        totalComparePrice.classList.add('hidden');
      }
    }

    if (discountElement) {
      if (variantComparePrice > variantPrice) {
        const discountPercentage = (((variantComparePrice - variantPrice) / variantComparePrice) * 100).toFixed(1);
        discountElement.textContent = `-${discountPercentage}%`;
        discountElement.classList.remove('hidden');
      } else {
        discountElement.classList.add('hidden');
      }
    }

    // Trigger change event on quantity input to recalculate volume discounts
    if (qtyInput) {
      qtyInput.dispatchEvent(new Event('change'));
    }
  }

  function updateAddToCartButton(variantId, isAvailable) {
    const buttons = form.querySelectorAll('button[name="add"]');
    buttons.forEach((button) => {

      if (button.getAttribute('data-open-form') != null) return false;
      
      button.disabled = !isAvailable;
      button.classList.toggle('opacity-50', !isAvailable);
      button.textContent = isAvailable
        ? button.classList.contains('md:hidden')
          ? 'Toevoegen' // Replace with your translation
          : 'Toevoegen aan winkelwagen' // Replace with your translation
        : 'Uitverkocht'; // Replace with your translation
    });

    // Update quantity input and buttons
    qtyInput.disabled = !isAvailable;
    plusBtn.classList.toggle('disabled', !isAvailable);
    minBtn.classList.toggle('disabled', !isAvailable);
  }

  function initializeProduct() {
    let productData;
    if (variantRadioButtons.length > 0) {
      // Product has variants
      const selectedVariant = document.querySelector('[data-variant-picker] input[type="radio"]:checked');
      console.log('selectedVariant', selectedVariant);
      if (selectedVariant) {
        productData = {
          variantId: selectedVariant.getAttribute('data-variant-id'),
          price: parseFloat(selectedVariant.getAttribute('data-variant-price')),
          comparePrice: parseFloat(selectedVariant.getAttribute('data-variant-compare-price')),
          isAvailable: selectedVariant.getAttribute('data-variant-available') === 'true',
          inventory: parseInt(selectedVariant.getAttribute('data-variant-inventory') || '0', 10),
        };
      }
    } else {
      // Product without variants
      productData = {
        variantId: variantIdField.value,
        price: parseFloat(form.querySelector('[data-product-price]')?.getAttribute('data-product-price') || '0'),
        comparePrice: parseFloat(
          form.querySelector('[data-product-compare-price]')?.getAttribute('data-product-compare-price') || '0'
        ),
        isAvailable: form.querySelector('[data-product-available]')?.getAttribute('data-product-available') === 'true',
        inventory: maxQuantity,
      };
    }

    if (productData) {
      if (variantIdField) {
        variantIdField.value = productData.variantId;
      }
      updatePrices(productData.price, productData.comparePrice);
      updateAddToCartButton(productData.variantId, productData.isAvailable);
      //maxQuantity = productData.inventory;
      maxQuantity = 1000000;
      qtyInput.setAttribute('data-max-quantity', maxQuantity);
      updateQuantity(Math.min(parseInt(qtyInput.value, 10), maxQuantity));

      console.log(maxQuantity);
      console.log(productData.isAvailable);

      if (maxQuantity == 0 && !productData.isAvailable) {
        stockNotification.classList.remove('hidden');
      } else {
        stockNotification.classList.add('hidden');
      }
    }
  }

  // Event listeners
  plusBtn.addEventListener('click', function () {
    console.log('click plusBtn');
    updateQuantity(parseInt(qtyInput.value, 10) + 1);
  });

  minBtn.addEventListener('click', function () {
    updateQuantity(parseInt(qtyInput.value, 10) - 1);
  });

  qtyInput.addEventListener('change', function () {
    updateQuantity(parseInt(this.value, 10), false);
  });

  variantRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener('change', initializeProduct);
  });

  // Initialize the productw
  initializeProduct();

  // Volume quantity functionality
  function initVolumeQuantityListeners() {
    // Function to add click listeners to volume quantity elements
    function addListeners() {
      const elements = document.querySelectorAll('[data-volume-quantity]');
      if (elements.length > 0) {
        elements.forEach((e) => {
          // Check if the listener has already been added
          if (!e.hasAttribute('data-listener-added')) {
            e.addEventListener('click', function () {
              const quantity = e.getAttribute('data-volume-quantity');
              updateQuantity(parseInt(quantity, 10), true);
            });
            // Mark the element as having a listener added
            e.setAttribute('data-listener-added', 'true');
          }
        });

        // If we found and processed elements, we can stop the interval
        clearInterval(checkInterval);
        console.log('Volume quantity listeners added successfully');
      }
    }

    // Set up an interval to check for elements every 500ms (half a second)
    const checkInterval = setInterval(addListeners, 500);

    // Optionally, stop checking after a certain amount of time (e.g., 10 seconds)
    setTimeout(() => {
      clearInterval(checkInterval);
      console.log('Stopped checking for volume quantity elements');
    }, 10000);
  }

  initVolumeQuantityListeners();
});

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '€{{amount}}';

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, '.');
    decimal = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
